import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Testimonials() {
  const testimonials = [
    {
      name: "Shamita, Bangalore",
      text: `I recently consulted Dr. Sannidhi for my gynecological concerns, and I had a very positive experience. Dr. Sannidhi was extremely patient, attentive, and took the time to listen to all my concerns without rushing through the appointment. I truly appreciated that she did not recommend any unnecessary tests or medications, which reflects her ethical and patient-first approach to treatment. The clinic itself is very clean, well-organized, and maintains high standards of hygiene, which made me feel safe and comfortable throughout my visit. The staff were courteous and helpful, creating a welcoming atmosphere from the moment I walked in. Overall, I felt well cared for and confident in the treatment I received. I highly recommend Dr. Sannidhi and her clinic to anyone looking for a trustworthy and compassionate gynecologist.`,
      rating: 4.5,
    },
    {
      name: "Trianaventures, Bangalore",
      text: `We visited the Famphy Clinic at Bhartiya Mall when our 3-year-old developed a persistent cough and mild fever. The pediatrician was extremely patient and caring—took the time to examine our child thoroughly and asked detailed questions about symptoms, diet, and sleep habits. What stood out was how gently the doctor interacted with our little one, making her feel comfortable and even playful during the check-up. The prescribed medications were mild and effective, and we noticed improvement within two days. The nurse and reception staff were also friendly and efficient, which made the overall experience smooth and stress-free for us as parents. I truly appreciated the personalized attention and calm environment. Definitely a reliable place for pediatric care!`,
      rating: 4.5,
    },
    {
      name: "Ira Singh, New Delhi",
      text: `I am extremely impressed by FamPhy - not least because of the prompt response to a medical emergency. I think it’s a much needed service and completely affordable.  It’s also really reassuring for people who have elderly parents to take care of. We are just really grateful we stumbled upon this- thanks to my sister in the U.S- and I have told a great many people about it and given them the contact number and website details.`,
      rating: 4.5,
    },
    {
      name: "Bimla Rani, Gurgaon",
      text: `Our Experience with FamPhy was very good. The doctor was a great guide in our mother’s health matters. His home visit was a big relief for us as she was not in the condition to be taken to the hospital. You are providing a valuable service to society`,
      rating: 4.5,
    },
    {
      name: "Surjit Singh, New Delhi",
      text: `Excellent Doctor , I have not seen a doctor like this in my whole life , He actually saved my father's life`,
      rating: 4.5,
    },{
      name: "Janak Pathak, Raksha Bhawan , New Delh",
      text: `Doctor was very good. If we feel like we want a doctor again we will definitely get back to you`,
      rating: 4.5,
    },{
      name: "Niloy Debnath , Chanakyapuri, New Delhi",
      text: `It was  quite a good experience because FamPhy was the only one who made it possible after we tried several others.`,
      rating: 4.5,
    },
    {
      name: "Bimla Rani Sachdeva, Palam Vihar, Gurgaon",
      text: `This is just to say, I'm thankful for the service FamPhy provided. As promised, the doctor visited within an hour. The doctor consulted the patient really well. We're extremely satisfied with the service.`,
      rating: 4.5,
    },
  ];

  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex) => setIndex(selectedIndex);

  return (
    <div className="container my-5 testimonials" id="testimonials">
      <div className="text-center mb-4">
        <h2>
          What <span>Our Patients</span> Have To Say
        </h2>
        <p className="limit-width">
          Specialized and general physicians who have many years of work experience in their respective fields.
        </p>
      </div>

      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        interval={8000}
        indicators={false}
        controls={true}
      >
        {testimonials.map((item, i) => (
          <Carousel.Item key={i}>
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="shadow p-4 rounded bg-white">
                  <h5>{item.name}</h5>
                  <p>{item.text}</p>
                  <div className="star-review">
                    {Array.from({ length: 5 }).map((_, j) => (
                      <span key={j} className="text-warning me-1">
                        <i
                          className={
                            j + 1 <= Math.floor(item.rating)
                              ? "fas fa-star"
                              : "fas fa-star-half-alt"
                          }
                        ></i>
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}
